// extracted by mini-css-extract-plugin
module.exports = {"scrollBar":"tabs_scrollBar__Qwp1b"};